import { render, staticRenderFns } from "./Usim.vue?vue&type=template&id=24c5108c"
import script from "./Usim.vue?vue&type=script&lang=js"
export * from "./Usim.vue?vue&type=script&lang=js"
import style0 from "./Usim.vue?vue&type=style&index=0&id=24c5108c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports